import React, { useState, useEffect, useContext } from "react";
import { Grid, Card, CardContent, Typography, Box, Button, CardMedia } from "@mui/material";
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from "@mui/material";
import "./ExitManagement.css";
import Context from "context/context";
import { toast } from "react-toastify";
import ReusableTable from "components/table/table";
import Tooltip from '@mui/material/Tooltip';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as moment from "moment";
import exitManagementAPI from "apis/panel/ExitManagement/exitManagement";
import swal from 'sweetalert';

import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from "@mui/icons-material/Close";




import {

  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper

} from "@mui/material";

const ExitManagement_final = () => {

  const [resignations, setResignations] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const { state, dispatch } = useContext(Context);
  const [count, setCount] = useState(0); // Add a count for pagination
  const [approvalReason, setApprovalReason] = useState("");
  const [HRlist, setHRlist] = useState(true);
  const [resignationDetails, setResignationDetails] = useState("");
  const [approval, setApproval] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
 const [originalLWD,setOriginalLWD] = useState(new Date()); 
  const [selectedLWD, setSelectedLWD] = useState(originalLWD);
  const [reasonForChange, setReasonForChange] = useState("");
  const [isLWDChanged, setIsLWDChanged] = useState(false);
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const limit = 10;
  const [offset, setOffset] = useState(1);

  const [openModal, setOpenModal] = useState(false);
  const [exitDetailsView, setExitDetailsView] = useState([])
  const [approvalDetails, setApprovalDetails] = useState([])

  const [selectedYear, setSelectedYear] = useState(new Date());

  const handleYearChange = (newYear) => {
    setSelectedYear(newYear);
    setOffset(1)
    setSearchValue("")
  };


  const [selectedAttrition, setSelectedAttrition] = useState("");
  const [remarks, setRemarks] = useState("");

  const { getHRCompletedResignationsAPI, getOneResignationsAPI, hrFinalApproveResignationAPI, getResignationApprovalDetailsAPI, hrCloseFinanceClearanceAPI } = exitManagementAPI()


  const handleOpenSubmitModal = async () => {
    let errors = {};

    if (!approval) {
      errors.approval = "Approval Status is required";
    }
    if (approval === "Approved" && !approvalReason.trim()) {
      errors.approvalReason = "Reason for approval is required";
    }


    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      toast.error("Please fill in the required fields.");
      return;
    }
    const confirmation = await swal({
      title: "Confirm",
      text: "Are you sure you want to proceed with closing this exit?",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Reject",
          value: false,
          visible: true,
          className: "swal-button-disagree",
        },
        confirm: {
          text: "Accept",
          value: true,
          visible: true,
          className: "swal-button-agree",
        },
      },
      dangerMode: false,
    });
    if (confirmation) {
      handleApproveResignation(resignationDetails.exitId)
    }
  };



  useEffect(() => {
    fetchAllResignations();
  }, [offset, selectedYear, searchValue]);


  const handleLWDChange = (newDate) => {
    if (!newDate) return;

    const formattedDate = moment(newDate).format("YYYY-MM-DD"); // Convert new date to same format

    setSelectedLWD(formattedDate);


    if (!moment(formattedDate).isSame(originalLWD, "day")) {
      setIsLWDChanged(true);
    } else {
      setIsLWDChanged(false);
      setReasonForChange("");
    }
  };

  

  const fetchAllResignations = async () => {


    try {

      let query = {
        offset: (offset - 1) * limit,
        limit: limit,
        year: selectedYear,

      }

      if (searchValue) {
        query = {
          ...query,
          searchValue,
        };
      }
     
      dispatch({ type: "SET_LOADING", payload: true });

     

      const data = await getHRCompletedResignationsAPI(query);

      if (data.status === "Ok" && Array.isArray(data.allResignations)) {
        setResignations(data.allResignations);
        setCount(data.count);
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignations:", error);
    } finally {
      // Clear the loading state after processing
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleFinanceClearance = async (exitId) => {
    const confirmation = await swal({
      title: "Confirm",
      text: "Do you want to close the finance clearance?",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Reject",
          value: false,
          visible: true,
          className: "swal-button-disagree",
        },
        confirm: {
          text: "Accept",
          value: true,
          visible: true,
          className: "swal-button-agree",
        },
      },
      dangerMode: false,
    });
    if (confirmation) {
      try {
        const body = {
          exitId: exitId,
          status: 'Completed',
        }
        dispatch({ type: "SET_LOADING", payload: true });
        const data = await hrCloseFinanceClearanceAPI(body);
        if (data.status === "Ok" && data.affected === 1) {
          toast.success("Finance Clearance Completed successfully");
          fetchAllResignations();
          dispatch({ type: "SET_LOADING", payload: false });
        } else {
          toast.error("Error: " + (data.message || "Clearance Completion failed"));

          dispatch({ type: "SET_LOADING", payload: false });
        }
      } catch (error) {
        console.log(error);

      }

    }
  }

  const tableDataModal = resignations.map((resignation, index) => [
    index + 1 + (offset - 1) * limit,
    resignation.employeeCode, // Employee Code
    resignation.firstName, // Name
    resignation.role, // Role
    resignation.dept, // Department
    resignation.requestStatus, // Request Status
    resignation?.attritionType,
    resignation?.appliedOn ? moment(resignation.appliedOn).format("DD-MMM-YYYY") : 'Not Available',

    resignation?.lwd ? moment(resignation.lwd).format("DD-MMM-YYYY") : 'Not Applicable',

    resignation.approvalStatus, // Approval Status
    <Tooltip title={resignation.financeStatus === "Pending" ? "Click to change clearance Status" : ""}
      key={resignation.exitId}>

      <button
        key={`toggle-${resignation.exitId}`}

        onClick={() => {

          if (resignation.financeStatus === "Pending") {

            handleFinanceClearance(resignation?.exitId);

          }
        }}

        style={{
          backgroundColor: resignation.financeStatus === "Completed" ? "#118f3fff" : "#7e7b70ff",
          color: "#fff",
          border: "none",
          padding: "4px 12px",
          borderRadius: "12px",
          width: "100px",           // fixed width for both buttons
          textAlign: "center",
          cursor: resignation.financeStatus === "Pending" ? "pointer" : "not-allowed",
        }}
      >
        {resignation.financeStatus || "Pending"}
      </button>
    </Tooltip>,
    <Tooltip title="Click to view approval screen" key={resignation.exitId}>
      <span className="jobType">
        <RemoveRedEyeIcon
          style={{
            color: resignation.approvalStatus != "Clearance Completed" ? "grey" : "#E97000",  // Grey when Final Approved, else orange
            cursor: resignation.approvalStatus != "Clearance Completed" ? "not-allowed" : "pointer", // Not allowed cursor when Final Approved
          }}
          onClick={() => {
            if (resignation.approvalStatus == "Clearance Completed") {
              fetchOneResignation(resignation.exitId); // Function to handle view action
            } else if (resignation.approvalStatus == "Final Approved") {
              toast.info("This resignation has been finalized and cannot be edited.");
            } else if (resignation.approvalStatus == "HR Approved") {
              toast.info("This resignation is waiting for clearance completion and hence cannot be edited.");
            }
          }}
        />
      </span>
    </Tooltip>,
    <Tooltip
      title={
        resignation.isMigrated
          ? "Migrated data – no details"
          : "Click to view approval Details"
      }
      key={resignation.exitId}
    >
      <span className="jobType">
        <InfoIcon
          style={{
            color: resignation.isMigrated
              ? "grey"
              : resignation.approvalStatus
                ? "#E97000"
                : "grey",
            cursor: resignation.isMigrated
              ? "not-allowed"
              : resignation.approvalStatus
                ? "pointer"
                : "not-allowed",
          }}
          onClick={() => {
            if (!resignation.isMigrated && resignation.approvalStatus) {
              handleOpenDetails(resignation)
            }
          }}
        />
      </span>
    </Tooltip>
  ]);



  const fetchOneResignation = async (exitId) => {
    try {

      dispatch({ type: "SET_LOADING", payload: true });

      const data = await getOneResignationsAPI(exitId);


      if (data.status === "Ok" && Array.isArray(data.oneResignation)) {

        const resignationDetails = data.oneResignation[0];


        setResignationDetails(resignationDetails);
        setSelectedAttrition(resignationDetails?.attritionType)
        setHRlist(false);
        setOriginalLWD(moment(resignationDetails.LWD).toDate())
        setSelectedLWD(moment(resignationDetails.LWD).toDate())
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignation details:", error);
    } finally {

      dispatch({ type: "SET_LOADING", payload: false });
    }
  };


  const handleApproveResignation = async (exitId) => {
    try {
// console.log(isLWDChanged,selectedLWD,reasonForChange,'l;k;lkl;;;');
// console.log(isLWDChanged);
// console.log(resignationDetails?.LWD != selectedLWD);
// console.log(resignationDetails?.LWD);




      const body = {
        exitId,
        // ...(isLWDChanged && {
        //   lastWorkingDay: selectedLWD,
        //   reasonForChange
        // }),
        ...(resignationDetails?.attritionType != selectedAttrition && {
          attritionType: selectedAttrition,
          attritionEditRemarks: remarks
        }),
        status: approval, // "Approved" 
        ...(isLWDChanged
          ? { lastWorkingDay: moment(selectedLWD).format("YYYY-MM-DD"), editReason: reasonForChange }
          : { lastWorkingDay: moment(resignationDetails?.LWD).format("YYYY-MM-DD") }),
        ...(approval === "Approved" && {
          approvalReason: approvalReason
        })

      };

      dispatch({ type: "SET_LOADING", payload: true });
      const data = await hrFinalApproveResignationAPI(body);
      if (data.status === "Ok" && data.affected == 1) {
        toast.success("Resignation approved successfully");

        fetchAllResignations();
        setHRlist(true);
        setIsSubmitModalOpen(false);
        handleClose()
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        toast.error("Error: " + (data.message || "Approval failed"));
        setIsSubmitModalOpen(false);
        handleClose()
        dispatch({ type: "SET_LOADING", payload: false });
      }

    } catch (error) {
      toast.error("Error approving resignation: " + error.message);

    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
      setIsSubmitModalOpen(false);
    }
  };


  const handleOpenDetails = async (exitDetails) => {
    try {

      dispatch({ type: "SET_LOADING", payload: true });

      const data = await getResignationApprovalDetailsAPI(exitDetails?.exitId);

      if (data.status === "Ok" && Array.isArray(data.oneResignation)) {

        const resignationDetails = data.oneResignation;

        setApprovalDetails(resignationDetails)
        setExitDetailsView(exitDetails)
        setOpenModal(true)

      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignation details:", error);
    } finally {

      dispatch({ type: "SET_LOADING", payload: false });
    }



  }

  const handleClose = () => {
    setOpenModal(false);
    setExitDetailsView(null);
    setApprovalDetails(null)
    setApproval("")
    setRejectionReason("")
    setApprovalReason("")
    setErrorMessages({})
  };



  return (
    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>



        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            mb: 2,
            position: "relative",

          }}
        >
          {/* This empty box takes space on the left so the title can truly center */}
          <Box sx={{ width: 150 }} />

          {/* Centered Title */}
          <Typography
            variant="h5"
            className="self-title"
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              whiteSpace: "nowrap",


            }}
          >
            Exit Closure Dashboard
          </Typography>

          {/* search bar */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,               // space between year picker & search
              mb: 2,
            }}
          >
            <TextField
              placeholder="Search by ID, Name"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setOffset(1); // reset pagination on search
              }}
              size="small"
              sx={{
                width: 250,
                '& .MuiInputBase-root': {
                  height: 40,
                },
              }}
            />

            {/* Year filter on right */}
            <Box sx={{
              color: '#fff', backgroundColor: '#1e8841ff', width: 140, '& .MuiInputBase-root': {
                height: 40,
                minHeight: '40px',

              },
              '& .MuiInputBase-input': {
                color: '#fff',  // input text color here
              },
              '& .MuiSvgIcon-root': {
                color: '#fff',  // calendar icon color
              },

            }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  views={["year"]}
                  value={selectedYear}
                  onChange={handleYearChange}
                  minDate={new Date("2005-01-01")}
                  maxDate={new Date()}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Box>
          </Box>
        </Box>


        {HRlist ? (

          <ReusableTable

            data={tableDataModal} // Pass the transformed data
            count={count}
            offset={offset}
            setOffset={setOffset}
            limit={limit}
            // searchBar={true}
            //  placeholder="Search by ID, Name"
            //  searchValue={searchValue}  
            // setSearchValue={setSearchValue}
            heading={[
              "S.No",
              "Employee Code",
              "Name",
              "Role",
              "Department",
              "Request Status",
              "Attrition Type",
              "Request Submission Date",

              "Last Working Day",

              "Approval Status",
              "Finance Clearance",
              "Action",
              "View Details"
            ]} // Table headers
          />
        ) : (
          <>
            <Grid container spacing={2} sx={{ pl: 6, pr: 5, pb: 5, mt: 2 }}>

              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                <Box className="label">Employee ID</Box>
                <TextField
                  sx={{ border: "1px solid #B2D4F8" }}
                  id="kraCategory"
                  name="kraCategory"
                  placeholder=""
                  variant="outlined"
                  fullWidth
                  disabled
                  value={resignationDetails.employeeCode}
                  InputProps={{ readOnly: true }} // Make it readonly
                />
              </Grid>


              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                <Box className="label">Employee Name </Box>
                <TextField
                  sx={{ border: "1px solid #B2D4F8" }}
                  id="kpiName"
                  name="kpiName"
                  placeholder=""
                  variant="outlined"
                  fullWidth
                  disabled
                  value={resignationDetails.firstName}
                  InputProps={{ readOnly: true }} // Make it readonly
                />
              </Grid>


              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                <Box className="label">Reason For Leaving</Box>
                <TextField
                  sx={{ border: "1px solid #B2D4F8" }}
                  id="kpiName"
                  name="kpiName"
                  placeholder=""
                  variant="outlined"
                  fullWidth
                  disabled
                  value={resignationDetails.exitReason}
                  InputProps={{ readOnly: true }} // Make it readonly
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                <Box className="label">Last Working Date</Box>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    id="lastWorkingDate"
                    name="lastWorkingDate"
                    value={resignationDetails ? moment(resignationDetails.LWD).toDate() : null}
                    // readOnly
                    // disabled
                    onChange={handleLWDChange}
                    format="dd/MM/yyyy"
                    slotProps={{ field: { clearable: true } }}
                    renderInput={(params) => <TextField {...params} helperText={null} />}
                  />
                </LocalizationProvider>
              </Grid>


              {isLWDChanged && (
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                  <Box className="label">
                    Reason for LWD Change<span style={{ color: "red" }}>*</span>
                  </Box>
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={reasonForChange}
                    onChange={(e) => setReasonForChange(e.target.value)}
                    placeholder="Enter reason for LWD change"
                  />
                </Grid>
              )}

              <Grid item xs={6} sm={3} md={3} lg={3} sx={{ mt: 2 }}>
                <Tooltip title="This represents the remaining leave balance in days">
                  <Box className="label">Balance Leaves (days)</Box>
                </Tooltip>
                <TextField
                  fullWidth
                  variant="outlined"
                  readOnly
                  disabled
                  type="number"
                  value={resignationDetails.balanceLeaves}

                  placeholder="Enter balance leaves"
                  sx={{ border: "2px solid #B2D6F8", borderRadius: "4px" }}
                />
              </Grid>

              <Grid item xs={6} sm={3} md={3} lg={3} sx={{ mt: 2 }}>
                <Tooltip title="This represents the Shortfall in Notice Period in days">
                  <Box className="label">Shortfall in Notice Period(days)</Box>
                </Tooltip>
                <TextField
                  fullWidth
                  variant="outlined"
                  readOnly
                  disabled
                  type="number"
                  value={resignationDetails.shortFallInNoticePeriod}

                  placeholder="Enter shortfall"
                  sx={{ border: "2px solid #B2D6F8", borderRadius: "4px" }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                <Box className="label">
                  Attrition Type <span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="reason-label"
                    id="reason"
                    placeholder="Select Attrition"
                    value={selectedAttrition}
                    displayEmpty
                    onChange={(e) => {
                      setSelectedAttrition(e.target.value);
                      setRemarks('')
                    }}
                    inputProps={{ "aria-label": "Attrition Type" }}
                    style={{ border: "1.5px solid #B2D4F8", color: "grey" }}

                  >
                    <MenuItem value="Voluntary">Voluntary</MenuItem>
                    <MenuItem value="Involuntary">Involuntary</MenuItem>
                  </Select>
                </FormControl>

              </Grid>

              {resignationDetails?.attritionType != selectedAttrition && (
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                  <Box className="label">Reason for attrition change<span style={{ color: "red" }}>*</span></Box>

                  <TextField
                    sx={{ border: "1px solid #B2D4F8" }}
                    id="justification"
                    name="justification"
                    placeholder="Enter reason for attrition change"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={3}
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value.trimStart())}
                    onBlur={(e) => setRemarks(e.target.value.trim())} />
                  {errorMessages.remarks && <FormHelperText>{errorMessages.remarks}</FormHelperText>}

                </Grid>
              )}


              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                <Box className="label">Approval Status<span style={{ color: "red" }}>*</span></Box>
                <FormControl fullWidth>
                  <Select
                    labelId="self-rating-label"
                    id="selfRating"
                    style={{ border: "2px solid #B2D6F8", color: "grey" }}
                    value={approval}
                    onChange={(e) => setApproval(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select</MenuItem>
                    <MenuItem value="Approved">Approve</MenuItem>

                  </Select>
                  {errorMessages.approval && <FormHelperText>{errorMessages.approval}</FormHelperText>}

                </FormControl>
              </Grid>
              {approval === "Approved" && (
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                  <Box className="label">Reason for Approval<span style={{ color: "red" }}>*</span></Box>

                  <TextField
                    sx={{ border: "1px solid #B2D4F8" }}
                    id="justification"
                    name="justification"
                    placeholder="Enter reason for approval"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    value={approvalReason}
                    onChange={(e) => setApprovalReason(e.target.value.trimStart())}
                    onBlur={(e) => setApprovalReason(e.target.value.trim())}

                  />
                  {errorMessages.approvalReason && <FormHelperText>{errorMessages.approvalReason}</FormHelperText>}

                </Grid>
              )}


            </Grid>
            <Grid container spacing={1} sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }} >
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button className="cancelButton" onClick={() => {
                  setSelectedLWD(originalLWD);
                  setIsLWDChanged(false);
                  setReasonForChange("");
                  setHRlist(true);
                  handleClose()
                }}>Cancel</Button>
              </Grid>
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button className="saveButton" onClick={() => handleOpenSubmitModal()}> Submit </Button>
              </Grid>
            </Grid>

          </>
        )}


{/* Exit details View */}
        <Dialog
          open={openModal}
          onClose={handleClose}
          PaperProps={{
            sx: {
              width: "900px",
              maxWidth: "90vw",
              borderRadius: "12px",
              padding: "20px",
              // marginTop: "50px",      // Push it down a bit from top
            },
          }}
          sx={{
            "& .MuiDialog-container": {
              alignItems: "flex-center",   // Align dialog to top instead of center
            },
          }}


        >
          <DialogTitle sx={{ fontSize: "18px", fontWeight: "bold", textAlign: "center", color: "#4a55cbff" }}>
            Employee Exit Progress Details
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "#666",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          {exitDetailsView && (
            <>
              <Grid container spacing={2} sx={{ mb: 3, mt: 1, justifyContent: "space-around" }}>
                <Grid item xs={12} sm={4} >
                  <strong >Employee Name:</strong> {exitDetailsView.firstName}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <strong>Request Status:</strong> {exitDetailsView.requestStatus}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <strong>Attrition Type:</strong> {exitDetailsView.attritionType}
                </Grid>

              </Grid>
              <TableContainer component={Paper}>
                <Table size="medium">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: "15%", minWidth: "120px" }}>
                        <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
                          Approval Level
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ width: "15%", minWidth: "120px" }}>
                        <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
                          Acted By
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ width: "15%", minWidth: "120px" }}>
                        <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
                          Status
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ width: "15%", minWidth: "120px" }}>
                        <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
                          Acted On
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ width: "15%", minWidth: "120px" }}>
                        <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
                          Reason/Remarks
                        </Typography>
                      </TableCell>


                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {[
                      "Manager (level 1)",
                      "Manager (level 2)",
                      "HR",
                      "IT",
                      "Admin",
                      "Finance",
                      "HR Final Approval"
                    ].map((levelName) => {
                      const detail = approvalDetails?.find(
                        (item) => item.approvalLevel === levelName
                      );


                      const getApprovalStatus = (approvalDetails, levelName) => {


                        if (!approvalDetails) return <span style={{ color: "gray", fontWeight: "bold" }}>Not Applicable</span>;
                        let status;
                        switch (levelName) {
                          case "Manager (level 1)":
                            status = approvalDetails?.managerStatus || "Pending";
                            break;
                          case "Manager (level 2)":
                            status = approvalDetails?.l2ManagerStatus || "Pending";
                            break;
                          case "HR":
                            status = approvalDetails?.HRStatus || "Pending";
                            break;
                          case "IT":
                            status = approvalDetails?.ITStatus || "Pending";
                            break;
                          case "Admin":
                            status = approvalDetails?.adminStatus || "Pending";
                            break;
                          case "Finance":
                            status = approvalDetails?.financeStatus || "Pending";
                            break;
                          case "HR Final Approval":
                            status = approvalDetails?.hrFinalApprovalStatus || "Pending";
                            break;
                          default:
                            status = approvalDetails?.approvalStatus || "Not Applicable";
                        }
                        let color;
                        switch (status) {
                          case "Approved":
                            color = "#327841ff";
                            break;
                          case "Completed":
                            color = "#327841ff";
                            break;
                          case "Pending":
                            color = "#727163ff";
                            break;
                          case "Rejected":
                            color = "#d02222ff";
                            break;
                          case "Not Applicable":
                            color = "#859ea3ff";
                            break;
                          default:
                            color = "black";
                        }

                        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
                      };

                      return (
                        <TableRow key={levelName}>
                          <TableCell>{levelName}</TableCell>
                          <TableCell>{detail?.approverName || "-"}</TableCell>
                          <TableCell>
                            {/* <Typography
  sx={{
    
    color:
      detail?.approvalStatus === "Approved" || detail?.approvalStatus === "Completed"
        ? "green"
        : detail?.approvalStatus === "Rejected"
        ? "red"
        : "#797c61ff", 
  }}
>
  {detail?.approvalStatus
          ? detail.approvalStatus
          : exitDetailsView.attritionType == "Voluntary" || (exitDetailsView?.requestStatus == 'Withdrawn' && levelName == 'Manager (level 1)')
          ? "Pending"
           :  exitDetailsView.attritionType == "Involuntary" && (exitDetailsView?.requestStatus == 'Termination Initiated' && levelName != 'Manager (level 1)' && levelName != 'HR' )
          ? "Pending"
          : "Not Applicable"}
</Typography> */}

                            {getApprovalStatus(approvalDetails[0], levelName)}
                          </TableCell>
                          <TableCell>
                            {detail?.date
                              ? moment(detail.date).format("DD-MM-YYYY")
                              : "-"}
                          </TableCell>
                          <TableCell>{detail?.remarks || "-"}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>

                </Table>
              </TableContainer>
            </>
          )}
        </Dialog>




      </Box>
    </div>
  );
};

export default ExitManagement_final;

